import React, { useEffect, useState, useRef } from "react";
import { CardContent, Grid, Paper, setRef } from "@material-ui/core";
import { HomeWrapper } from "../components/utils/HomeWrapper";
import { PageTitle } from "../components/utils/PageTitle";
import ReactPlayer from "react-player";
import Select from '@mui/material/Select';
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardContent";
import CloseIcon from '@mui/icons-material/Close';
import UndoIcon from "@mui/icons-material/Undo";
import { Button, Link } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowCircleLeftRoundedIcon from '@mui/icons-material/ArrowCircleLeftRounded';
import ArrowCircleRightRoundedIcon from '@mui/icons-material/ArrowCircleRightRounded';
import AnalyticsIcon from '@mui/icons-material/Analytics';

import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';

import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';

import { styled } from '@mui/material/styles';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import MuiAccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';

import TwitterIcon from '@mui/icons-material/Twitter';
import InstagramIcon from '@mui/icons-material/Instagram';

import { SignaMedLogo } from '../components/utils/SignaMedLogo';
import TravelExploreIcon from '@mui/icons-material/TravelExplore';
import { RankingSuccess6 } from "../utils/icons";

import { pDatasetBuilderStates } from "../utils/parameters";
import { pDataProvider } from "../utils/parameters";
import { useDataProvider } from "../api/DataProvider";
import { useCommProvider } from "../api/CommProvider";
import { VersusMachineDialog } from "../components/versusMachineDialog/VersusMachineDialog";
import { Tooltip, withStyles } from '@material-ui/core';
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
var lodash = require('lodash');



import "../styles/devices/mob_VersusMachine.css";
import "../styles/devices/mob_Hub.css";


const Accordion = styled((props) => (
  <MuiAccordion disableGutters elevation={0} square {...props} />
))(({ theme }) => ({
  borderBottomLeftRadius: '10px', 
  borderBottomRightRadius: '10px'
}));

const AccordionSummary = styled((props) => (
  <MuiAccordionSummary
    expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem', color: 'white', marginRight: '10px'}} />}
    {...props}
  />
))(({ theme }) => ({
  flexDirection: 'row-reverse',
  '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
    transform: 'rotate(90deg)'
  },
}));

const AccordionDetails = styled(MuiAccordionDetails)(({ theme }) => ({
  backgroundColor: 'white',
  border: '1px solid #5ea0d4', 
  borderBottomLeftRadius: '10px', 
  borderBottomRightRadius: '10px'
}));


const SCREEN_INIT = 1
const SCREEN_ACTION = 2
const TEMPLATE_ELEMENTS_RESPONSE = {
      'arr_gloss_id': [],
      'arr_lemmas_request': [],
      'arr_lemmas_options': [],
      'arr_lemmas_annotated': Array(10).fill(""),
      'arr_counter_repeats': Array(10).fill(0),
      'speed': Array(10).fill(3),
      'duration': 0,
      'hits': [],
    }

export function VersusMachine() {
  const { t } = useTranslation("global")

  const { comm_getPublicURLVideoData } = useDataProvider();

  const [ activeScreen, setActiveScreen ] = useState(SCREEN_INIT)
  const { token_id, currentUser } = useDataProvider();
  const { comm_getDataVersusMachine, comm_sendResultsVersusMachine } = useCommProvider();

  const [openDialog, setOpenDialog] = useState(false);

  const [ elements_requested, setElements_requested ] = useState([]);
  const [ elements_response, setElements_response ] = useState(TEMPLATE_ELEMENTS_RESPONSE);
  const [ server_report_activity, setServer_report_activity ] = useState({})


  const [ counter_element_actived, setCounter_element_actived ] = useState(-1);
  const [ url_vid_keypoints, set_url_vid_keypoints ] = useState('');
  const [ url_vid_overlay, set_url_vid_overlay ] = useState('');

  // COMPONNTE SELECT
  const [ indexSelectedComponentSelect, setIndexSelectedComponentSelect ] = useState(-1)
  const [ arr_lemmasComponentSelect, setArr_lemmasComponentSelect ] = useState([]);

  // const [ counter_repeats_used, setCounter_repeats_used ] = useState(0)

  const [ video_play, setVideo_play ] = useState(true)
  const [ isCompleted, setIsCompleted ] = useState(false)

  const [ timestamp_init, setTimestamp_init] = useState(0)
  const [ accordionExpanded, setAccordionExpanded ] = useState(false)

  const history = useHistory();


  useEffect(() => {
    // console.log('counter_element_actived: ', counter_element_actived)
    if (counter_element_actived > -1 && elements_requested[0] !== undefined) {

      setArr_lemmasComponentSelect(elements_response['arr_lemmas_options'][counter_element_actived])

      if (elements_response['arr_lemmas_annotated'][counter_element_actived] === "") {
        setIndexSelectedComponentSelect(-1)
      }else{
        setIndexSelectedComponentSelect(elements_response['arr_lemmas_options'][counter_element_actived].indexOf(elements_response['arr_lemmas_annotated'][counter_element_actived]))
      }

      set_url_vid_keypoints(comm_getPublicURLVideoData(pDataProvider.dir_vid_versusKeypoints, elements_requested[counter_element_actived].gloss_id))
      set_url_vid_overlay(pDataProvider.dir_vid_versusOverlay, elements_requested[counter_element_actived].gloss_id)

    }
  }, [counter_element_actived]);



  useEffect(() => {    
    if (elements_requested !== undefined) {
      if (elements_requested[0] !== undefined) { //This check was throwing an error trying to access [0] of undefined. Could be deleted.
        let elements_response_values = TEMPLATE_ELEMENTS_RESPONSE
        elements_response_values['arr_gloss_id'] = elements_requested.map((item) => item.gloss_id)

        // elements_requested.map((item, index) => {
        //   // const list_lemmas_similar = item.arr_lemmas_similarity
        //   // const list_lemma_labels = item.arr_lemma_labels

        //   const list_lemmas_similar = lodash.sampleSize(item.arr_lemmas_similarity, 6);
        //   const list_lemma_labels = lodash.sampleSize(item.arr_lemma_labels, 1);
          
        //   const lemma_label_selected = lodash.sample(list_lemma_labels);
        //   const combinedArray = lodash.concat(list_lemmas_similar, lemma_label_selected);
        //   const shuffledArray = lodash.shuffle(combinedArray);
        //   elements_response_values['arr_lemmas_request'][index] = lemma_label_selected
        //   elements_response_values['arr_lemmas_options'][index] = shuffledArray
        // })


        elements_requested.map((item, index) => {
          elements_response_values['arr_lemmas_request'][index] = item.lemma_label
          elements_response_values['arr_lemmas_options'][index] = lodash.shuffle(item.arr_lemmas_similarity)
        })
    
        setElements_response(elements_response_values)
        setIndexSelectedComponentSelect(-1)
        setCounter_element_actived(0)
        setVideo_play(true)
    }
  }

  }, [elements_requested]);

  useEffect(() => {
    // console.log(' isCompleted elements_response: ', elements_response)
    if (elements_response.arr_lemmas_request !== undefined) {
      if (elements_response.arr_lemmas_annotated.length > 0) {

        // console.log('isCompleted proceso: ', elements_response.arr_lemmas_annotated)

      
        const statusIsCompleted = elements_response.arr_lemmas_annotated.every((element) => element !== "")
        // console.log(' isCompleted proceso check: ',statusIsCompleted)
        setIsCompleted(statusIsCompleted)
      }
    }
  }, [elements_response]);

  // useEffect(() => {
  //   console.log('change isCompleted')
  //   if (isCompleted) {
  //     console.log('isCompleted: ', isCompleted)
  //   }else{
  //     console.log('isCompletedd: ', isCompleted)
  //   }
  // }, [isCompleted]);

  // useEffect(() => {
  //   console.log('elements_response: ', elements_response)
  // }, [elements_response]);
  


  async function obtainData(){
    // console.log('obtainData')
    setElements_requested(await comm_getDataVersusMachine(token_id, currentUser))
  }

  
  const clickAnnotation = (event) => {
    setIndexSelectedComponentSelect(event.target.value)
    // console.log('event.target.value: ', event.target.value)
    let lemma = arr_lemmasComponentSelect[event.target.value]
    if (lemma === undefined) {
      lemma = ""
    }
    // console.log('lemma: ', lemma)

    setElements_response(prevState => {
      const newSent = [...prevState.arr_lemmas_annotated];
      newSent[counter_element_actived] = lemma;
  
      return {
        ...prevState,
        arr_lemmas_annotated: newSent
      };
    });

  };



  const clickBtnRepeat = (event) => {
    // setCounter_repeats_used(counter_repeats_used + 1)
    

    // setElements_response(prevState => {
    //   const newCounterRepeatsUsed = [...prevState.arr_counter_repeats];
    //   newCounterRepeatsUsed[counter_element_actived] += 1;
    //   return {
    //     ...prevState,
    //     arr_counter_repeats: newCounterRepeatsUsed
    //   };
    // });


    setElements_response(prevState => {
      let newCounterRepeatsUsed = [...prevState.arr_counter_repeats];
      newCounterRepeatsUsed[counter_element_actived] += 1;

      let newSpeed = [...prevState.speed];
      if (newSpeed[counter_element_actived] > 1){
        newSpeed[counter_element_actived] -= 1;
      }
  
      return {
        ...prevState,
        arr_counter_repeats: newCounterRepeatsUsed,
        speed: newSpeed
      };
    });

    setVideo_play(true)
  
  };

  const endVideo = (event) => {
    setVideo_play(false)
  };

  const initVersusMachine = () => {
    setActiveScreen(SCREEN_ACTION);
    obtainData()
    setTimestamp_init(new Date().getTime())
  };

  const returnMenuVersusMachine = () => {
    console.log('returnMenuVersusMachine')
    setActiveScreen(SCREEN_INIT);
    
    set_url_vid_keypoints('')
    set_url_vid_overlay('')
    setCounter_element_actived(-1)
    setIndexSelectedComponentSelect(-1)
    setElements_requested([])
    setElements_response({
      'arr_gloss_id': [],
      'arr_lemmas_request': [],
      'arr_lemmas_options': [],
      'arr_lemmas_annotated': Array(10).fill(""),
      'arr_counter_repeats': Array(10).fill(0),
      'speed': Array(10).fill(3),
      'duration': 0,
      'hits': [],
    })
  };


  // useEffect(() => {
  //   console.log("🚀 ~ file: VersusMachine.js:118 ~ VersusMachine ~ indexSelectedComponentSelect:", indexSelectedComponentSelect)  
  // }, [indexSelectedComponentSelect]);


  // useEffect(() => {
  //   console.log("🚀 ~ file: VersusMachine.js:118 ~ VersusMachine ~ elements_requested:", elements_requested)  
  // }, [elements_requested]);
  

  const clickBtnNext = () => {
    // console.log('clickBtnNext')
    if (counter_element_actived < 10) {
      const new_counter_element_actived = counter_element_actived + 1

      setCounter_element_actived(new_counter_element_actived)
      setVideo_play(true)

    }
  };

  const clickBtnBack = () => {
    // console.log('clickBtnBack')
    if (counter_element_actived > 0) {

      const new_counter_element_actived = counter_element_actived - 1

      setCounter_element_actived(new_counter_element_actived)
      setVideo_play(true)

    }
  };

  const completeSession = () => {

    const updatedElementsResponse = { ...elements_response };
    updatedElementsResponse.arr_lemmas_annotated = [...elements_response.arr_lemmas_request];
    setElements_response(updatedElementsResponse);

  }

  async function btn_Send_Server() {
    // setAnnotation(event.target.value)
    const hits = elements_response['arr_lemmas_request'].map((element, index) => {
      return (element === elements_response['arr_lemmas_annotated'][index]) ? 1 : 0
    });

    const duration_session_ms = Date.now() - timestamp_init
    // console.log("🚀 ~ file: VersusMachine.js:250 ~ btn_Send_Server ~ duration_session_ms:", duration_session_ms)

    let elements_response_send = elements_response
    elements_response_send['hits'] = hits
    elements_response_send['duration'] = duration_session_ms
    setElements_response(elements_response_send)

    setOpenDialog(true)

    console.log('Send data and receive report')
    setServer_report_activity(await comm_sendResultsVersusMachine(token_id, currentUser, elements_response_send))

  }

  async function btn_Send_Server_Only_Ranking() {
   
    setOpenDialog(true)
    setServer_report_activity(await comm_sendResultsVersusMachine(token_id, currentUser, {}))

  }

  // useEffect(() => {
  //   console.log("🚀 ~ file: VersusMachine.js:341 ~ VersusMachine ~ server_report_activity:", server_report_activity)
  // }, [server_report_activity]);

  const handleAccordionChange = () => {
    setAccordionExpanded(!accordionExpanded);
  };



  const btn_Open_Report = () => {
    history.push({
      pathname: "/reports",
      src: "/versusMachine"
    });
  };


  return (
    <HomeWrapper>
      <VersusMachineDialog openDialog={openDialog} setOpenDialog={setOpenDialog} elements_requested={elements_requested} elements_response={elements_response} server_report_activity={server_report_activity} returnMenuVersusMachine={returnMenuVersusMachine}/>
      <PageTitle title= {t("sVersusMachine.title").toUpperCase()} />

      {activeScreen === SCREEN_INIT ? (
        <div className="sig_VersusMachine_Start_Screen">
          <Card className="sig_VersusMachine_CardContainer">
              
            <div className="sig_VersusMachine_CardActionArea">

              <Accordion className="sig_VersusMachine_AccordionRoot" expanded={accordionExpanded} onChange={handleAccordionChange}>
                <AccordionSummary className="sig_VersusMachine_AccordionSummary" >
                    <p> {t("sVersusMachine.endChallenge")} </p>
                    <p> {t("sVersusMachine.endChallenge2")} </p>
                </AccordionSummary>
                <AccordionDetails className="sig_VersusMachine_AccordionDetails">
                    <p> {t("sVersusMachine.showResults")}
                      <Tooltip title={t("sTooltip.blog_signamed")} placement='right' arrow>
                        <Link href="https://signamed.uvigo.es/usuario-contra-la-maquina-resultados-del-reto" target="_blank" ><TravelExploreIcon style={{color: '#1DA1F2'}} /></Link>
                      </Tooltip>
                    </p>
                    <p> {t("sVersusMachine.showResults2")} </p>
                </AccordionDetails>
              </Accordion>

              <Paper className="sig_VersusMachine_PaperContent">     
                <div className="sig_Hub_InfoTitle sig_VersusMachine_Start_Title"> {t("sVersusMachine.btnStartQuestion")} </div>
                <Button className="sig_Hub_ButtonBig sig_Hub_Card_ButtonModal sig_VersusMachine_Fix" onClick={initVersusMachine}>
                  {" "}
                  {t("sVersusMachine.btnStart").toUpperCase()}
                  {" "}
                </Button>                
                <Button className="sig_Hub_ButtonBig sig_Hub_Card_ButtonModal sig_VersusMachine_Fix" onClick={btn_Send_Server_Only_Ranking}>
                  {" "}
                  <EmojiEventsIcon className="sig_VersusMachine_Start_Icon" fontSize="large"/> {t("sVersusMachine.btnShowClasification").toUpperCase()} {" "}
                </Button>
              </Paper>
              <Paper className="sig_VersusMachine_PaperContent"> 
                <Button className=" sig_Hub_Card_ButtonModal" onClick={btn_Open_Report}>
                   {" "}
                   {t("sVersusMachine.btnShowReport").toUpperCase()}
                   {" "}
                </Button>
              </Paper>
            </div>
          </Card>
        </div> 
      ) : (
        <Grid className="sig_DataSet_Root" container>
          <Card className="sig_DataSet_CardContainer">
            <CardActionArea className={`sig_DataSet_CardActionArea sig_DataSet_ExpandedArea sig_VersusMachine_DataSetFix`}>
              <Grid className="sig_DataSet_ActionAreaContainer sig_VersusMachine_DataSetFix" container>
                <Grid item>
                  <Button className="sig_VersusMachine_Cancel_Button" onClick={returnMenuVersusMachine}>
                    {" "}
                    <CloseIcon fontSize="inherit" /> <span> {t("strButton.btn_exit").toUpperCase()} </span>{" "}
                  </Button>

                  <Tooltip 
                    classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                    placement="top"
                    arrow
                    title={
                      <div className="sig_CustomTooltip_Content">
                        <p>
                          {t("sVersusMachine.btn_speed_button_info").split('.').map((item, key) => {
                            return <p key={key}>{item.trim()}</p>;
                          })}
                        </p>
                      </div>
                    }>
                    <span className="sig_VersusMachine_SpeedIndicator"> <RankingSuccess6/> x{elements_response['speed'][counter_element_actived]}</span>
                  </Tooltip> 
                  
                  {
                    <ReactPlayer
                      width="480px"
                      height="480px"
                      className="sig_VersusMachine_ReactPlayer"
                      url={url_vid_keypoints}
                      onEnded={endVideo}
                      // url={videoLoaded}
                      playbackRate={elements_response['speed'][counter_element_actived]}
                      controls={false}
                      playing={video_play}
                      //playing = {true}
                      loop={false}
                    />
                  }

                  <div className="sig_VersusMachine_Controls">
                    <Button style={{}} onClick={clickBtnBack}>
                      {" "}
                      <ArrowCircleLeftRoundedIcon className={`sig_VersusMachine_Arrow_Button ${counter_element_actived == 0 ? "sig_VersusMachine_Arrow_Button_Hide" : ""}`} />{" "}
                    </Button>
                    <span className="sig_VersusMachine_Counter">{counter_element_actived + 1} - 10</span>
                    <Button onClick={clickBtnNext}>
                      <ArrowCircleRightRoundedIcon className={`sig_VersusMachine_Arrow_Button ${counter_element_actived == 9 ? "sig_VersusMachine_Arrow_Button_Hide" : ""}`} />
                    </Button>
                  </div>
                </Grid>

                <Grid className="sig_DataSet_ActionArea" item>
                  <Grid className="sig_VersusMachine_ActionAreaColumn" container>
                    <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonRepeatContainer" item>
                      <Button className="sig_DataSet_ButtonRepeat sig_VersusMachine_DataSetFix" color="primary" variant="contained" disabled={video_play} onClick={clickBtnRepeat}>
                        {elements_response['speed'][counter_element_actived] > 2 ? t("sVersusMachine.btn_repeat_speed2x").toUpperCase() : t("sVersusMachine.btn_repeat_speed1x").toUpperCase()}
                      </Button>
                    </Grid>

                    <Grid item>
                      <FormControl className="sig_DataSet_Form sig_DataSet_FormAnotation">
                        <InputLabel> {t("sVersusMachine.label_sign")} </InputLabel>
                        {/* <Select className="sig_DataSet_MenuList" value={indexSelectedComponentSelect} label="Anotación" onChange={clickAnnotation}> */}

                        <Select className="sig_DataSet_MenuList" value={indexSelectedComponentSelect} label={t("sVersusMachine.label_sign")} onChange={clickAnnotation}>
                          <MenuItem className="sig_DataSet_MenuListItem" value="">
                            <em> {t("strButton.no_selection")} </em>
                          </MenuItem>
                          {arr_lemmasComponentSelect.map((item, index) => {
                            return (
                              <MenuItem className="sig_DataSet_MenuListItem" key={item} value={index}>
                                {item}
                              </MenuItem>
                            );
                          })}
                        </Select>
                      </FormControl>
                    </Grid>

                    {/* <Button className="sig_VersusMachine_Start_Button" color="primary" variant="contained" onClick={completeSession}>FORZAR FINALIZACIÓN</Button> */}

                    {isCompleted === false ? (
                      <Tooltip 
                        classes={{arrow: "sig_CustomTooltip_Arrow", tooltip: "sig_CustomTooltip_Container"}}
                        placement="top"
                        arrow
                        title={
                          <div className="sig_CustomTooltip_Content">
                            <span> {t("sVersusMachine.btn_end_notice")} </span>
                          </div>
                        }>
                        <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer sig_VersusMachine_DatasetFix" item>
                          <Button className="sig_DataSet_ButtonConfirm" variant="outlined" color="success" disabled={!isCompleted} onClick={btn_Send_Server}>
                            {t("sVersusMachine.btn_end")}
                          </Button>
                        </Grid>
                      </Tooltip>  
                    ):(
                      <Grid className="sig_DataSet_ButtonContainer sig_DataSet_ButtonConfirmContainer sig_VersusMachine_DatasetFix" item>
                        <Button className="sig_DataSet_ButtonConfirm" variant="outlined" color="success" disabled={!isCompleted} onClick={btn_Send_Server}>
                          {t("sVersusMachine.btn_end")}
                        </Button>
                      </Grid>
                    )}

                  </Grid>
                </Grid>
              </Grid>
            </CardActionArea>
          </Card>
        </Grid>
      )}
    </HomeWrapper>
  );
  }
